import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { servicesApi as n } from "@maat/api-main";
//#region src/services/useServicesQuery.ts
var r = (r = {}) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.listServices({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useServicesQuery };
